import React from 'react'
import { Edit2 } from 'iconsax-react'
import useStyles from './styles'

const Edit = ({ open, data }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Edit2 className={classes.icon} onClick={open(data)} />
    </div>
  )
}

export default Edit
